/* appy-store.js - boutique behaviour wired to the Shopify AJAX Cart.
   Cart (add/get/change) · drawer · free-shipping bar · bundle→variant · sticky ATC
   · gallery · accordion · header · fade-up · quiz. No fake urgency, no fake social. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function icons() {}
  var SVG = function (inner) { return '<svg class="appy-i" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>'; };
  var IC = {
    minus: SVG('<path d="M5 12h14"/>'),
    plus: SVG('<path d="M5 12h14"/><path d="M12 5v14"/>'),
    check: SVG('<path d="M20 6 9 17l-5-5"/>'),
    x: SVG('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>')
  };

  var root = $('#appyStore');
  var THRESHOLD = root ? parseFloat(root.getAttribute('data-free-threshold') || '0') : 0; // in major units (€)
  var THRESHOLD_LABEL = root ? (root.getAttribute('data-free-label') || 'la livraison offerte') : 'la livraison offerte';
  var money = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  var ADDONS = [];
  try { var _ael = $('#appyAddonsData'); if (_ael) ADDONS = JSON.parse(_ael.textContent || '[]'); } catch (e) { ADDONS = []; }
  function renderAddons(cart) {
    if (!ADDONS.length) return '';
    var inCart = (cart.items || []).map(function (it) { return String(it.variant_id); });
    var avail = ADDONS.filter(function (a) { return inCart.indexOf(String(a.variant)) === -1; });
    if (!avail.length) return '';
    var h = '<div class="cart-addons"><h5>On y ajoute ?</h5>';
    avail.forEach(function (a) {
      h += '<div class="addon"><div class="addon-img" style="background-image:url(\'' + (a.img || '') + '\')"></div>' +
        '<div class="addon-info"><h6>' + a.name + '</h6><span>' + money(a.price) + '</span></div>' +
        '<button class="addon-add" data-addon-variant="' + a.variant + '">+ Ajouter</button></div>';
    });
    return h + '</div>';
  }

  /* ---------- Shopify cart ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Drawer render ---------- */
  function renderCart(cart) {
    var c = cart.item_count;
    $$('.cart-count').forEach(function (el) { el.textContent = c; el.classList.toggle('show', c > 0); });
    var body = $('#drawerBody');
    if (body) {
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Votre panier est vide.</p></div>';
      } else {
        var html = '';
        cart.items.forEach(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
          html += '<div class="cart-line">' +
            '<div class="cart-line-img" style="background-image:url(\'' + img + '\')"></div>' +
            '<div class="cart-line-info"><h4>' + it.product_title + '</h4>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="price">' + it.variant_title + '</div>' : '') +
            '<div class="price">' + money(it.final_price) + '</div>' +
            '<div class="qty"><button data-dec="' + it.key + '" aria-label="Moins">' + IC.minus + '</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '" aria-label="Plus">' + IC.plus + '</button></div>' +
            '</div>' +
            '<button class="cart-line-remove" data-rm="' + it.key + '">Retirer</button>' +
            '</div>';
        });
        html += renderAddons(cart);
        body.innerHTML = html;
      }
    }
    if (THRESHOLD > 0) {
      var sub = cart.items_subtotal_price / 100;
      var remain = Math.max(0, THRESHOLD - sub);
      var pf = $('#progressFill'), pt = $('#progressText');
      if (pf) pf.style.width = Math.min(100, sub / THRESHOLD * 100) + '%';
      if (pt) pt.innerHTML = remain > 0
        ? 'Plus que <b>' + money(remain * 100) + '</b> pour ' + THRESHOLD_LABEL
        : '<b>' + THRESHOLD_LABEL.charAt(0).toUpperCase() + THRESHOLD_LABEL.slice(1) + '</b> débloquée ! 🎁';
    }
    var tot = $('#drawerTotal'); if (tot) tot.textContent = money(cart.items_subtotal_price);
    var foot = $('#drawerFoot'); if (foot) foot.style.display = (cart.items && cart.items.length) ? 'block' : 'none';
    icons();
  }
  function refresh() { return getCart().then(renderCart); }

  /* ---------- Drawer open/close ---------- */
  function openDrawer() { var d = $('#drawer'), o = $('#overlay'); if (d) { d.classList.add('open'); o.classList.add('show'); d.setAttribute('aria-hidden', 'false'); } }
  function closeDrawer() { var d = $('#drawer'), o = $('#overlay'); if (d) { d.classList.remove('open'); o.classList.remove('show'); d.setAttribute('aria-hidden', 'true'); } }
  function pulse() { $$('.icon-btn.cart').forEach(function (b) { if (b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'cubic-bezier(.22,.61,.36,1)' }); }); }
  function toast(msg) {
    var zone = $('#toastZone'); if (!zone) return;
    var t = document.createElement('div'); t.className = 'toast toast-atc';
    t.innerHTML = IC.check + '<span>' + msg + '</span>';
    zone.appendChild(t); icons();
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  /* ---------- Bundle selector → variant ---------- */
  var selected = null;
  function selectBundle(el) {
    if (!el) return;
    selected = el;
    $$('.bundle').forEach(function (b) { b.classList.toggle('selected', b === el); });
    var price = parseInt(el.getAttribute('data-price') || '0', 10);
    var was = parseInt(el.getAttribute('data-was') || '0', 10);
    var amt = $('#atcAmt'); if (amt) amt.textContent = money(price);
    var saNow = $('#saNow'); if (saNow) saNow.textContent = money(price);
    var saSave = $('#saSave'); if (saSave) saSave.textContent = was > price ? '− ' + money(was - price) : '';
  }
  function selectedVariantId() {
    if (selected) return selected.getAttribute('data-variant-id');
    var first = $('.bundle'); return first ? first.getAttribute('data-variant-id') : null;
  }
  function doAdd(variantId) {
    if (!variantId) return;
    addToCart(variantId, 1).then(function () { return refresh(); }).then(function () {
      toast('Ajouté au panier'); pulse(); setTimeout(openDrawer, 280);
    }).catch(function () { toast('Oups, réessayez.'); });
  }

  /* ---------- Global click wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (t) {
      var a = t.getAttribute('data-action');
      if (a === 'open-cart') { e.preventDefault(); openDrawer(); }
      else if (a === 'close-cart') { closeDrawer(); }
      else if (a === 'open-menu') { var m = $('#mobileMenu'); if (m) m.classList.add('open'); }
      else if (a === 'close-menu') { var m2 = $('#mobileMenu'); if (m2) m2.classList.remove('open'); }
      else if (a === 'add-selected') { e.preventDefault(); doAdd(selectedVariantId()); }
      else if (a === 'open-quiz') { e.preventDefault(); openQuiz(); }
      return;
    }
    var inc = e.target.closest('[data-inc]'); if (inc) { qtyDelta(inc.getAttribute('data-inc'), +1); return; }
    var dec = e.target.closest('[data-dec]'); if (dec) { qtyDelta(dec.getAttribute('data-dec'), -1); return; }
    var rm = e.target.closest('[data-rm]'); if (rm) { changeLine(rm.getAttribute('data-rm'), 0).then(renderCart); return; }
    var ad = e.target.closest('[data-addon-variant]'); if (ad) { addToCart(ad.getAttribute('data-addon-variant'), 1).then(refresh).then(function () { toast('Ajouté au panier'); pulse(); }); return; }
    if (e.target.id === 'overlay') closeDrawer();
  });
  function qtyDelta(key, d) {
    var span = null;
    $$('.cart-line').forEach(function (l) { if ($('[data-inc="' + key + '"]', l) || $('[data-dec="' + key + '"]', l)) span = $('.qty span', l); });
    var cur = span ? parseInt(span.textContent, 10) : 1;
    changeLine(key, Math.max(0, cur + d)).then(renderCart);
  }

  $$('.bundle').forEach(function (b) { b.addEventListener('click', function () { selectBundle(b); }); });
  if ($('.bundle')) selectBundle($('.bundle.selected') || $('.bundle'));

  /* ---------- Header stuck ---------- */
  var header = $('#header');
  if (header) { var onS = function () { header.classList.toggle('is-stuck', window.scrollY > 8); }; window.addEventListener('scroll', onS, { passive: true }); onS(); }

  /* ---------- Sticky ATC ---------- */
  var sticky = $('#stickyAtc'), anchor = $('#buyboxAnchor');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Gallery (rail + drag-follow swipe + dots + lightbox zoom) ---------- */
  (function () {
    var main = $('.gallery-main');
    if (!main) return;
    var track = $('.gallery-track', main);
    if (!track) return;
    var slides = $$('.slide', track);
    var thumbs = $$('.gallery-thumb');
    var dots = $$('.gallery-dot', main);
    var n = slides.length;
    var cur = 0;
    var swiped = false;

    /* Perf : les slides 2+ portent leur image en data-bg (pas de background inline)
       pour laisser la bande passante au LCP. Hydratation au window.load, à la
       première interaction galerie, ou après 2,5 s — premier arrivé. */
    var bgHydrated = false;
    function hydrateBgs() {
      if (bgHydrated) return;
      bgHydrated = true;
      $$('[data-bg]', main.parentElement || main).forEach(function (el) {
        el.style.backgroundImage = "url('" + el.getAttribute('data-bg') + "')";
      });
    }
    if (document.readyState === 'complete') { hydrateBgs(); }
    else { window.addEventListener('load', hydrateBgs, { once: true }); }
    main.addEventListener('pointerdown', hydrateBgs, { once: true });
    main.addEventListener('touchstart', hydrateBgs, { once: true, passive: true });

    function settle(animate) {
      main.classList.toggle('is-dragging', animate === false);
      track.style.transform = 'translate3d(' + (-cur * main.clientWidth) + 'px,0,0)';
    }
    function setActive() {
      slides.forEach(function (s, i) { s.classList.toggle('active', i === cur); });
      thumbs.forEach(function (t) { t.classList.toggle('active', parseInt(t.getAttribute('data-i'), 10) === cur); });
      dots.forEach(function (d) { d.classList.toggle('active', parseInt(d.getAttribute('data-i'), 10) === cur); });
    }
    function goTo(i) {
      if (!n) return;
      cur = (i + n) % n;
      main.classList.remove('is-dragging');
      setActive();
      track.style.transform = 'translate3d(' + (-cur * main.clientWidth) + 'px,0,0)';
    }

    thumbs.forEach(function (th) { th.addEventListener('click', function () { goTo(parseInt(th.getAttribute('data-i'), 10)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-i'), 10)); }); });

    if (n > 1) {
      var prev = $('.gallery-nav--prev', main), next = $('.gallery-nav--next', main);
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); goTo(cur - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); goTo(cur + 1); });
      main.setAttribute('tabindex', '0');
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      });

      /* finger-follows-image drag */
      var startX = 0, startY = 0, baseX = 0, w = 0, decided = false, horiz = false, dragging = false, moved = 0, t0 = 0;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        w = main.clientWidth; baseX = -cur * w;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        decided = false; horiz = false; dragging = true; moved = 0; swiped = false; t0 = Date.now();
      }, { passive: true });
      main.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dx = e.touches[0].clientX - startX, dy = e.touches[0].clientY - startY;
        if (!decided) {
          if (Math.abs(dx) > Math.abs(dy) + 4) { decided = true; horiz = true; }
          else if (Math.abs(dy) > Math.abs(dx) + 4) { dragging = false; return; }
          else return;
        }
        e.preventDefault();
        moved = dx; if (Math.abs(dx) > 6) swiped = true;
        var x = baseX + dx, min = -(n - 1) * w, max = 0;
        if (x > max) x = max + (x - max) * 0.35;
        else if (x < min) x = min + (x - min) * 0.35;
        main.classList.add('is-dragging');
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
      }, { passive: false });
      main.addEventListener('touchend', function () {
        if (!dragging) { settle(); return; }
        dragging = false;
        if (!horiz) return;
        var vel = Math.abs(moved) / Math.max(Date.now() - t0, 1), th = w * 0.18;
        if (moved <= -th || (moved < -8 && vel > 0.45)) goTo(cur + 1);
        else if (moved >= th || (moved > 8 && vel > 0.45)) goTo(cur - 1);
        else goTo(cur);
      });

      window.addEventListener('resize', function () { goTo(cur); }, { passive: true });
    }

    /* tap on an image → open zoom lightbox (skip after a swipe, skip video) */
    main.addEventListener('click', function (e) {
      if (swiped) { swiped = false; return; }
      if (e.target.closest('.gallery-nav') || e.target.closest('.gallery-dots')) return;
      var slide = e.target.closest('.slide');
      if (!slide || slide.classList.contains('slide--video') || e.target.closest('video')) return;
      openLightbox(cur);
    });

    setActive();
    settle();

    /* ----- Lightbox: pinch-zoom + pan + double-tap + swipe (nav/close) ----- */
    var IMGS = slides.filter(function (s) { return !s.classList.contains('slide--video'); })
      .map(function (s) { return s.getAttribute('data-src'); });
    var lb = null, lbImg = null, lbDots = null, lbIdx = 0;
    var scale = 1, tx = 0, ty = 0;

    function apply() { lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function clampPan() {
      var st = $('.lb-stage', lb);
      var mx = Math.max(0, (lbImg.clientWidth * scale - st.clientWidth) / 2);
      var my = Math.max(0, (lbImg.clientHeight * scale - st.clientHeight) / 2);
      tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
    }
    function reset() { scale = 1; tx = 0; ty = 0; lbImg.style.transition = ''; apply(); }
    function show(i) {
      lbIdx = (i + IMGS.length) % IMGS.length;
      lbImg.src = IMGS[lbIdx]; reset();
      if (lbDots) $$('.lb-dot', lbDots).forEach(function (d, k) { d.classList.toggle('active', k === lbIdx); });
    }
    function dist(t) { return Math.hypot(t[1].clientX - t[0].clientX, t[1].clientY - t[0].clientY); }

    function build() {
      lb = document.createElement('div');
      lb.className = 'appy-lightbox';
      var dotsHtml = IMGS.length > 1 ? '<div class="lb-dots">' + IMGS.map(function () { return '<span class="lb-dot"></span>'; }).join('') + '</div>' : '';
      lb.innerHTML = '<button class="lb-close" aria-label="Fermer">' + IC.x + '</button><div class="lb-stage"><img class="lb-img" alt=""></div>' + dotsHtml;
      document.body.appendChild(lb);
      lbImg = $('.lb-img', lb); lbDots = $('.lb-dots', lb);
      var stage = $('.lb-stage', lb);
      var g = { mode: '', sx: 0, sy: 0, sd: 0, ss: 1, stx: 0, sty: 0, moved: false, pv: 0, pvy: 0, lastTap: 0, lastEnd: 0 };

      lb.addEventListener('click', function (e) {
        if (Date.now() - g.lastEnd < 400) return; // ignore synthetic click after touch
        if (e.target.closest('.lb-close') || e.target === lb || e.target.classList.contains('lb-stage')) closeLightbox();
      });
      stage.addEventListener('touchstart', function (e) {
        lbImg.style.transition = 'none';
        if (e.touches.length === 2) { g.mode = 'pinch'; g.sd = dist(e.touches); g.ss = scale; }
        else { g.mode = 'one'; g.sx = e.touches[0].clientX; g.sy = e.touches[0].clientY; g.stx = tx; g.sty = ty; g.moved = false; g.pv = 0; g.pvy = 0; }
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (g.mode === 'pinch' && e.touches.length === 2) {
          e.preventDefault();
          scale = Math.max(1, Math.min(4, g.ss * dist(e.touches) / g.sd));
          clampPan(); apply();
        } else if (g.mode === 'one' && e.touches.length === 1) {
          var dx = e.touches[0].clientX - g.sx, dy = e.touches[0].clientY - g.sy;
          if (Math.abs(dx) + Math.abs(dy) > 6) g.moved = true;
          e.preventDefault();
          if (scale > 1) { tx = g.stx + dx; ty = g.sty + dy; clampPan(); apply(); }
          else {
            g.pv = dx; g.pvy = dy;
            if (Math.abs(dy) > Math.abs(dx)) lbImg.style.transform = 'translateY(' + (dy > 0 ? dy : dy * 0.3) + 'px) scale(1)';
            else lbImg.style.transform = 'translateX(' + dx + 'px) scale(1)';
          }
        }
      }, { passive: false });
      stage.addEventListener('touchend', function () {
        lbImg.style.transition = ''; g.lastEnd = Date.now();
        if (g.mode === 'pinch') { if (scale < 1.05) reset(); else { clampPan(); apply(); } g.mode = ''; return; }
        if (g.mode !== 'one') return;
        if (!g.moved) {
          var now = Date.now();
          if (now - g.lastTap < 300) { g.lastTap = 0; if (scale > 1) reset(); else { scale = 2.5; apply(); } }
          else { g.lastTap = now; apply(); }
          g.mode = ''; return;
        }
        if (scale > 1) { g.mode = ''; return; }
        if (Math.abs(g.pvy) > Math.abs(g.pv) && g.pvy > 90) { closeLightbox(); g.mode = ''; return; }
        if (Math.abs(g.pv) > 60 && IMGS.length > 1) { show(g.pv < 0 ? lbIdx + 1 : lbIdx - 1); g.mode = ''; return; }
        reset(); g.mode = '';
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('show')) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowRight' && IMGS.length > 1) show(lbIdx + 1);
        else if (e.key === 'ArrowLeft' && IMGS.length > 1) show(lbIdx - 1);
      });
    }
    function openLightbox(i) {
      if (!IMGS.length) return;
      if (!lb) build();
      show(i); lb.classList.add('show'); document.documentElement.style.overflow = 'hidden';
    }
    function closeLightbox() { if (lb) { lb.classList.remove('show'); document.documentElement.style.overflow = ''; } }
  })();

  /* ---------- Accordion ---------- */
  $$('.acc-head').forEach(function (h) {
    h.addEventListener('click', function () {
      var item = h.closest('.acc-item'); var body = $('.acc-body', item);
      var open = item.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
    });
  });
  $$('.acc-item.open').forEach(function (item) { var b = $('.acc-body', item); if (b) b.style.maxHeight = b.scrollHeight + 'px'; });

  /* ---------- fade-up ---------- */
  var fades = $$('.fade-up');
  if (fades.length && 'IntersectionObserver' in window) {
    var fo = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); fo.unobserve(en.target); } }); }, { threshold: 0.12 });
    fades.forEach(function (f) { fo.observe(f); });
  } else { fades.forEach(function (f) { f.classList.add('in'); }); }

  /* ---------- Quiz « Trouver mon match » (reco → variante Shopify) ---------- */
  var quizPop = $('#quizPop');
  var QIC = {
    droplet: SVG('<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/>'),
    milk: SVG('<path d="M8 2h8"/><path d="M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2"/><path d="M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0"/>'),
    heart: SVG('<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>'),
    sun: SVG('<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>'),
    car: SVG('<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/>'),
    plane: SVG('<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>'),
    baby: SVG('<path d="M9 12h.01"/><path d="M15 12h.01"/><path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"/><path d="M12 3a9 9 0 0 0-9 9 9 9 0 0 0 18 0 9 9 0 0 0-9-9z"/>'),
    gift: SVG('<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/>'),
    users: SVG('<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>')
  };
  var QUIZ = [
    { key: 'alim', q: 'Comment nourrissez-vous bébé ?', sub: 'Pour viser la bonne température, à coup sûr.', opts: [
      { ic: 'droplet', t: 'Lait maternel tiré', s: 'Sorti du frigo, à préserver', v: 'maternel' },
      { ic: 'milk', t: 'Lait infantile', s: 'Préparé à la maison ou en route', v: 'infantile' },
      { ic: 'heart', t: 'Les deux', s: 'Allaitement mixte', v: 'mixte' } ] },
    { key: 'sortie', q: 'À quelle fréquence sortez-vous ?', sub: "On adapte l'autonomie à votre rythme.", opts: [
      { ic: 'sun', t: 'Tous les jours', s: 'Crèche, balades, courses', v: 'quotidien' },
      { ic: 'car', t: 'Trajets & voiture', s: 'Allers-retours réguliers', v: 'trajets' },
      { ic: 'plane', t: 'Voyages & week-ends', s: 'Journées entières sans prise', v: 'voyage' } ] },
    { key: 'qui', q: "C'est pour…", sub: '', opts: [
      { ic: 'baby', t: 'Mon bébé', s: 'Un seul foyer', v: 'solo' },
      { ic: 'gift', t: 'Un cadeau', s: 'Naissance, liste', v: 'cadeau' },
      { ic: 'users', t: 'Jumeaux / 2 lieux', s: 'Maison + nounou', v: 'duo' } ] }
  ];
  function recoFor(a) {
    if (a.qui === 'duo' || a.qui === 'cadeau') return { idx: 2, name: 'Appy GO™ Duo', why: 'Deux warmers (ou un joli cadeau prêt à offrir), accessoires inclus.' };
    if (a.sortie === 'voyage') return { idx: 1, name: 'Appy GO™ Voyage', why: 'Batterie supplémentaire + trousse isotherme pour tenir la journée entière sans prise.' };
    return { idx: 0, name: 'Appy GO™', why: "L'essentiel, compatibilité résolue d'emblée : warmer + 3 bagues + pochette." };
  }
  function variantForReco(idx) { return root ? root.getAttribute('data-variant-' + (idx + 1)) : null; }
  var quizState = { step: 0, answers: {} };
  function renderQuiz() {
    var inner = $('#quizInner'); if (!inner) return;
    if (quizState.step < QUIZ.length) {
      var q = QUIZ[quizState.step];
      var pills = QUIZ.map(function (_, i) { return '<div class="quiz-pill' + (i <= quizState.step ? ' on' : '') + '"></div>'; }).join('');
      var opts = q.opts.map(function (o) {
        return '<button class="quiz-opt" data-qval="' + o.v + '"><span class="q-ic">' + (QIC[o.ic] || '') + '</span><span><span class="q-t">' + o.t + '</span><span class="q-s">' + o.s + '</span></span></button>';
      }).join('');
      inner.innerHTML = '<div class="quiz-step active"><div class="quiz-pill-row">' + pills + '</div><h3 class="quiz-q">' + q.q + '</h3>' + (q.sub ? '<p class="quiz-sub">' + q.sub + '</p>' : '') + opts + '</div>';
    } else {
      var reco = recoFor(quizState.answers);
      var seal = root ? root.getAttribute('data-seal') : '';
      inner.innerHTML = '<div class="quiz-step active quiz-result">' +
        (seal ? '<img class="seal" src="' + seal + '" alt="">' : '') +
        '<h3 class="quiz-q">Votre match : ' + reco.name + '</h3>' +
        '<div class="quiz-match"><div><div class="qm-name">' + reco.name + '</div><div class="qm-why">' + reco.why + '</div></div></div>' +
        '<div class="quiz-gift">' + QIC.gift + ' Votre pochette de transport offerte sur cette sélection.</div>' +
        '<form class="quiz-form" id="quizForm"><input type="email" required placeholder="Votre e-mail pour recevoir votre match"><button class="btn btn-accent btn-block" type="submit">Ajouter mon match au panier</button></form>' +
        '<p class="quiz-fine">On vous envoie votre sélection et un mot d’explication. Pas de spam, désinscription en un clic.</p></div>';
      var form = $('#quizForm');
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = variantForReco(reco.idx);
        closeQuiz();
        if (vid) doAdd(vid);
      });
    }
  }
  function openQuiz() { if (!quizPop) return; quizState = { step: 0, answers: {} }; renderQuiz(); quizPop.classList.add('show'); }
  function closeQuiz() { if (quizPop) quizPop.classList.remove('show'); }
  if (quizPop) {
    quizPop.addEventListener('click', function (e) {
      if (e.target.classList.contains('quiz-bg') || e.target.closest('.quiz-close')) { closeQuiz(); return; }
      var opt = e.target.closest('.quiz-opt');
      if (opt) {
        quizState.answers[QUIZ[quizState.step].key] = opt.getAttribute('data-qval');
        quizState.step++;
        renderQuiz();
      }
    });
  }

  /* ---------- Swipe-to-dismiss (drawer/menu → right, quiz sheet → down) ---------- */
  function dragDismiss(el, panel, axis, onClose, scrollGuard) {
    if (!el || !panel) return;
    var s = 0, c = 0, d = 0, on = false, decided = false, go = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { on = false; return; }
      if (scrollGuard && !scrollGuard()) { on = false; return; }
      s = axis === 'x' ? e.touches[0].clientX : e.touches[0].clientY;
      c = axis === 'x' ? e.touches[0].clientY : e.touches[0].clientX;
      d = 0; on = true; decided = false; go = false;
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!on) return;
      var p = (axis === 'x' ? e.touches[0].clientX : e.touches[0].clientY) - s;
      var x = (axis === 'x' ? e.touches[0].clientY : e.touches[0].clientX) - c;
      if (!decided) {
        if (p > Math.abs(x) + 4) { decided = true; go = true; panel.style.transition = 'none'; }
        else { decided = true; go = false; return; } // wrong direction or cross-axis → let it scroll
      }
      if (!go) return;
      if (p < 0) p = 0;
      d = p; e.preventDefault();
      panel.style.transform = axis === 'x' ? 'translateX(' + p + 'px)' : 'translateY(' + p + 'px)';
    }, { passive: false });
    el.addEventListener('touchend', function () {
      if (!on) return; on = false;
      panel.style.transition = ''; panel.style.transform = '';
      if (go && d > 80) onClose();
    });
  }
  dragDismiss($('#drawer'), $('#drawer'), 'x', closeDrawer);
  (function () { var mm = $('#mobileMenu'); dragDismiss(mm, mm, 'x', function () { if (mm) mm.classList.remove('open'); }); })();
  (function () {
    var card = quizPop ? $('.quiz-card', quizPop) : null;
    dragDismiss(card, card, 'y', closeQuiz, function () { return !card || card.scrollTop <= 0; });
  })();

  /* ---------- init ---------- */
  icons();
  refresh();
  window.AppyStore = { openCart: openDrawer, refresh: refresh, add: doAdd };
})();
